import { Progress, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import FileReader from 'components/Uploader/FileReader'
import Uploadloader from 'components/Uploader/Uploader'
import React, { useEffect, useState } from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import { usePrevious } from '../../../../utils/helpers'
import { SubHeading } from '../style'
import { useTpoConfig } from '../../hooks/useTpoConfig'
const CVupload = ({
  studentFormData,
  studentData,
  updateStatusPending,
  updateStudentData,
  setCurrent,
  updateCvDetails,
  activeKey,
  setInitialLoading,
  initalLoading,
  getStudentData,
  form = null,
}) => {
  const [cvDetails, setCvDetails] = useState(studentData?.cvUrl || {})
  const [loading, setLoading] = useState(initalLoading)
  const prevCvUrl = usePrevious(studentData?.cvUrl?.url || '') // Use the usePrevious hook
  const [progress, setProgress] = useState(0)
  
  const { frozenFields } = useTpoConfig(
    studentFormData?.student?.instituteCampusId,
    studentFormData
  )
  useEffect(() => {
    setInitialLoading(false)
    setLoading(false)
    setCvDetails(studentData?.cvUrl)
  }, [studentData])
  const uploadCV = async (file, submit = false) => {
    let isUpdated = false
    setLoading(true)
    if (!submit) {
      setCvDetails(file)
    }
    let cvData = studentData?.cvDetails
    // for service
    if (
      file &&
      submit &&
      (cvDetails?.url !== prevCvUrl ||
        (cvDetails?.url == prevCvUrl && cvData && !Object.keys(cvData)?.length))
    ) {
      const interval = setInterval(() => {
        setProgress(prevProgress => {
          const nextProgress = prevProgress + 10
          if (nextProgress >= 100) {
            clearInterval(interval)
            return 100
          }
          return nextProgress
        })
      }, 2000)
      isUpdated = await updateCvDetails(studentData?.id, {
        url: file?.url,
      })
      if (isUpdated) {
        setProgress(100)
        setTimeout(() => {
          setCurrent(activeKey + 1)
        }, 2000)
      } else {
        setLoading(false)
        setProgress(0)
        ErrorMessage('Failed to parse this CV !')
      }
    } else if (submit) {
        setTimeout(() => {
          setCurrent(activeKey + 1)
        }, 1000)
      }
    

    if (!submit) {
      if (!studentFormData?.admin?.dob) delete studentFormData?.admin?.dob
      if (!studentFormData?.admin?.gender) delete studentFormData?.admin?.gender
      // Preserve profileUrl - get from form if available (newly uploaded) or from existing data
      if (!form?.getFieldValue('profileUrl') && !studentFormData?.student?.profileUrl)
        delete studentFormData?.student?.profileUrl
      if (!studentFormData?.studentPersonalProfile?.permPostCode)
        delete studentFormData?.studentPersonalProfile?.permPostCode
      if (!studentFormData?.studentPersonalProfile?.corrPostCode)
        delete studentFormData?.studentPersonalProfile?.corrPostCode
      if (!studentFormData?.studentPersonalProfile?.secondaryEmail)
        delete studentFormData?.studentPersonalProfile?.secondaryEmail
      let payload = {
        admin: {
          ...studentFormData.admin,
        },
        student: {
          ...studentFormData.student,
          profileUrl: form?.getFieldValue('profileUrl') || studentFormData?.student?.profileUrl, // Get profile picture from form or existing
          cvUrl: file ?? {},
        },
        studentPersonalProfile: {
          ...studentFormData?.studentPersonalProfile,
        },
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? {
              ...studentFormData?.currentCourse,
              skills:
                studentFormData?.currentCourse?.skills == null
                  ? []
                  : studentFormData?.currentCourse?.skills,
            }
          : {},
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},

        education: studentFormData?.education,
        resume: studentFormData?.resume,
        checkForApproval: true,
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      studentFormData?.education?.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.markSheetUrl === null)
          delete payload?.education[index]?.markSheetUrl
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
      })

      let response = await updateStudentData(studentData?.id, payload)
      if (response === true) {
        setLoading(false)
      } else {
        setLoading(false)

        ErrorMessage(
          response?.response?.data?.message ?? 'Something went wrong'
        )
      }
    }
  }

  return (
    <Flex column center>
      <SubHeading flexStart>Upload your Resume here !</SubHeading>
      {loading ? (
        !progress || progress == 100 ? (
          <Spin />
        ) : (
          <Control center>
            <Progress percent={progress} type="circle" />
          </Control>
        )
      ) : (
        <>
          {cvDetails && Object?.keys(cvDetails ?? {})?.length > 0 ? (
            <Control column top="10px" center>
              <FileReader
                file={{
                  ...cvDetails,
                  name: cvDetails?.name?.replace(studentData?.id + '_', ''),
                }}
                setFile={!frozenFields.cv ? uploadCV : undefined}
                isView={frozenFields.cv}
              />
            </Control>
          ) : (
            <Control column top="10px" center>
              <Uploadloader
                setFile={!frozenFields.cv ? uploadCV : undefined}
                isDefault={true}
                disabled={frozenFields.cv}
                fileName={
                  studentData?.id +
                  '_' +
                  studentFormData?.admin?.firstName
                    ?.toLowerCase()
                    ?.replace(/\s/g, '') +
                  '_cv'
                }
                onlyDoc
              />
            </Control>
          )}
          <Control top="25px" flexEnd gap={'10px'}>
            {/* {!Object?.keys(cvDetails ?? {})?.length && ( */}
            <Button.Secondary text="Skip" onClick={() => setCurrent(1)} />
            {/* )} */}
            <Button.Primary
              text="Save and Continue"
              disabled={!Object?.keys(cvDetails ?? {})?.length}
              onClick={() => uploadCV(cvDetails, true)}
            />
          </Control>
        </>
      )}
    </Flex>
  )
}

export default CVupload
